<template>
    <div class="privacypolicy-page">
        <page-hero title="Privacy Policy" eyebrow="The League" compact />
        <div class="cl-page">
            <v-container>
                <v-card class="cl-card cl-card--light cl-reading">
                    <div class="row text">
                        <div class="col col-12">
                            <span>
                                <p class="text-center"><strong>PRIVACY POLICY</strong></p>
                                <p />
                                <p><strong><em>Intro and
                                    Summary</em></strong></p>
                                <p />
                                <p><span style="font-weight: 400;">Your privacy is
                                    important to B.I.G.. We process information that concerns you (hereinafter referred
                                    to as “Data”), always with respect to your rights and relevant EU legislation. In this
                                    policy, we want to inform you about how we process your personal data and about your
                                    rights. This policy also explains how we process Data that we have at our disposal from
                                    any contact, relationship or transaction with you, as well as for any other
                                    reason.Personal data is any information that can be connected to you as a private
                                    person, for example name and contact information.</span></p>
                                <p><span style="font-weight: 400;">In short, this is why
                                    we process your data:</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span
                                        style="font-weight: 400;"
                                    >To the extent necessary for providing our services to
                                        you.</span></li>
                                </ul>
                                <p><span style="font-weight: 400;"> offline.</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >To communicate with you and answer your questions.</span>
                                    </li>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >To ask you about B.I.G. and your experience with
                                        us.</span></li>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >To notify you of changes to our services.</span></li>
                                </ul>
                                <p />
                                <p><span style="font-weight: 400;">You have several rights
                                    according to data protection law. For example you always have a right to object against
                                    marketing. </span></p>
                                <p />
                                <p><span style="font-weight: 400;">Do you want to know
                                    more? Please read our detailed explanations below. </span></p>
                                <p />
                                <p><span style="font-weight: 400;">Below you can read more
                                    about </span><em><span

                                    style="font-weight: 400;"
                                >how</span></em><span

                                    style="font-weight: 400;"
                                >, </span><em><span

                                    style="font-weight: 400;"
                                >why and for how long period we process your personal
                                    data</span></em><span style="font-weight: 400;">.</span></p>
                                <p />
                                <p><strong><em>How we collect
                                    them</em></strong></p>
                                <p><span style="font-weight: 400;">We collect information
                                    in different ways through the website/application, such as:</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >Player Registrations</span></li>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >Cookies and Other Technologies</span></li>
                                </ul>
                                <p><strong><em>What Data do we
                                    collect</em></strong></p>
                                <p><span style="font-weight: 400;">We collect the
                                    following Data:</span></p>
                                <p><span style="font-weight: 400;">Your personal
                                    information, which are included during the registration procedure that you send
                                    us.</span></p>
                                <p><span style="font-weight: 400;">Information about the
                                    Internet Protocol (IP address), the time of your access to the website, the URL, the
                                    type and settings of your web browser. Also, information about your recent visits to our
                                    website and about the material you saw during your visit. We collect this information
                                    through cookies and other technologies we use, only with your consent, unless they are
                                    necessary for your browsing of the website. They are anonymous and we can not identify
                                    you through them.</span></p>
                                <p><strong><em>Reason we process
                                    them</em></strong></p>
                                <p><span style="font-weight: 400;">We process these Data
                                    only if necessary for:</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >Processing your request and take the appropriate steps so
                                        that we can have the best possible relationship with you and improve our
                                        products.</span></li>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >Understand how you use our website and make it more
                                        functional and secure.</span></li>
                                </ul>
                                <p><span style="font-weight: 400;">In some cases we may
                                    need to use the Data to:</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >Comply with our legal obligations.</span></li>
                                </ul>
                                <p><strong><em>How long will we keep
                                    them?</em></strong></p>
                                <p><span style="font-weight: 400;">We process the Data
                                    only for as long as is necessary to fulfill the purposes for which we collected it. We
                                    periodically review the Data we have stored and proceed to delete it, when it is no
                                    longer necessary for the fulfillment of these purposes. Specifically:</span></p>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >We retain information about your requests as long as it
                                        takes to review them and take appropriate action.</span></li>
                                    <li aria-level="1" style="font-weight: 400;"><span

                                        style="font-weight: 400;"
                                    >We retain the information we collect through the use of
                                        cookies and logs, in accordance with the Cookies and Other Technologies
                                        Policy.</span></li>
                                </ul>
                                <p><strong><em>Security</em></strong>
                                </p>
                                <p><span style="font-weight: 400;">We take the appropriate
                                    technical and organizational measures for the secure processing of the Data, in order to
                                    avoid unauthorized access, modification or disclosure.</span></p>
                                <p />
                                <p />
                                <p />
                                <p />
                                <p><strong><em>Data Protection
                                    Officer</em></strong></p>
                                <p>
                                    <span style="font-weight: 400;">
                                        If you have any
                                        questions about our data processing activities, the data controller you should contact
                                        is ivalmas@backinthegame.gr(Data Protection Officer).
                                    </span>
                                </p>
                                <p />
                                <p><strong><em>How can you affect our
                                    processing of your personal data?</em></strong></p>
                                <p />
                                <p><span style="font-weight: 400;">According to data
                                    protection legislation, you are entitled to a variety of rights to affect our processing
                                    of your personal data. Read more below.</span></p>
                                <p><span style="font-weight: 400;">Once we have collected
                                    your information we are very aware of the rights you retain with regard to it. These
                                    rights are laid out in the General Data Protection Regulations (GDPR) and are provided
                                    for your reference below.</span></p>
                                <p><strong>Subject to certain limitations on certain
                                    rights, you have the following rights in relation to your information:</strong></p>
                                <ul>
                                    <li><span style="font-weight: 400;" /><strong>The right to be informed</strong><span

                                        style="font-weight: 400;"
                                    >— you have the right to obtain confirmation as to whether
                                        or not we are processing personal data concerning you and to request a copy of the
                                        information that we hold about you.</span></li>
                                    <li><span style="font-weight: 400;" /><strong>The right of access</strong><span

                                        style="font-weight: 400;"
                                    >— you have the right to access your personal data that we
                                        hold.</span></li>
                                    <li><span style="font-weight: 400;" /><strong>The right to rectification</strong><span

                                        style="font-weight: 400;"
                                    >— you have the right to have inaccurate personal data
                                        rectified, or completed if it is incomplete.</span></li>
                                    <li><span style="font-weight: 400;" /><strong>The right to erasure, also known as “the right to be forgotten”
                                    </strong><span style="font-weight: 400;">— under certain
                                        circumstances, you have the right to request erasure of your personal data. This is
                                        the case for example where the personal data is no longer necessary for the purposes
                                        for which they were collected or otherwise processed, or you withdraw your consent
                                        on which the processing is based and where there is no other legal ground for
                                        continuance of the processing.</span></li>
                                    <li>
                                        <span style="font-weight: 400;" />
                                        <strong>The right to restrict processing</strong>
                                        <span style="font-weight: 400;">— you have the right to request the restriction or
                                            suppression of your personal data. That is the case for example when the accuracy of
                                            the personal data is contested by you, or the processing is unlawful, and you oppose
                                            the erasure of the personal data and instead requests restriction of its use.
                                        </span>
                                    </li>
                                    <li>
                                        <span style="font-weight: 400;" />
                                        <strong>The right to data portability</strong>
                                        <span style="font-weight: 400;">— you have the right to ask us to transfer certain of your
                                            personal data we have about you to another company (data portability) and reuse your
                                            personal data for your own purposes across different services. This right applies to
                                            personal data that you have provided us in a structured commonly used,
                                            machine-readable and interoperable format if:
                                        </span>
                                    </li>
                                </ul>
                                <ul>
                                    <li aria-level="1" style="font-weight: 400;">
                                        <span style="font-weight: 400;">The processing is based on consent or on a contract and</span>
                                    </li>
                                    <li aria-level="1" style="font-weight: 400;">
                                        <span style="font-weight: 400;">The processing is carried out by automated means.</span>
                                    </li>
                                </ul>
                                <p />
                                <p><span style="font-weight: 400;">In exercising your
                                    right to data portability, you have the right to have personal data transmitted directly
                                    from B.I.G. to another controller, where technically feasible.</span></p>
                                <p />
                                <ul>
                                    <li>
                                        <span style="font-weight: 400;" />
                                        <strong>The right to object</strong>
                                        <span style="font-weight: 400;">— you have the right to, entirely or partly, withdraw a
                                            given consent for the processing of your personal data. Your withdrawal will have
                                            effect from the time of your withdrawal. You have the right to object
                                        </span>
                                        <em>
                                            <span style="font-weight: 400;"> to
                                            </span>
                                        </em>
                                        <span style="font-weight: 400;">our processing of
                                            your personal data. You always have a right to object to marketing from us, such as
                                            newsletters.
                                        </span>
                                    </li>
                                </ul>
                                <p />
                                <ul>
                                    <li><span style="font-weight: 400;" /><strong>Rights in relation to automated decision making and
                                        profiling</strong><span style="font-weight: 400;">— you have the
                                        right not to be subject to a decision in respect to automated decision making and
                                        profiling.</span></li>
                                </ul>
                                <p />
                                <ul>
                                    <li><span style="font-weight: 400;" /><strong>The right to lodge a complaint to a supervisory
                                        authority</strong><span style="font-weight: 400;">— if you
                                        consider that your rights are violated in any way, you have the right to lodge a
                                        complaint with a supervisory authority (Hellenic Data Protection Authority). You may
                                        do this in particular in the EU/EEA member state of your habitual residence, place
                                        of work or of an alleged infringement of the applicable data protection laws. In
                                        Greece, the supervisory authority is the Hellenic Data Protection Authority. This
                                        right is without prejudice to any other administrative or judicial remedy.</span>
                                    </li>
                                    <li><strong />
                                        <strong>Identity confirmation:</strong>
                                        <span

                                            style="font-weight: 400;"
                                        >
                                            In case of doubt we can request additional information to
                                            verify your identity. This serves to protect your rights and private spheres.
                                        </span>
                                    </li>
                                    <li><strong /><strong>Misuse
                                        of rights: </strong><span style="font-weight: 400;">If you
                                        execute any of these rights too often and with obvious intent of misuse, we may
                                        charge you an administrative fee or decline to process your request.</span></li>
                                </ul>
                                <p />
                                <p><strong><em>Changes to the privacy
                                    policy</em></strong></p>
                                <p><span style="font-weight: 400;">B.I.G. reserves the
                                    right to modify or amend the Privacy Policy at any time and for any reason, as permitted
                                    by applicable law. If there are material changes to the Privacy Policy, it will be
                                    updated here. For this reason we advise you to check its content regularly.</span></p>
                                <p />
                                <p><span style="font-weight: 400;">This privacy policy was adopted by B.I.G. on ….. September 2024.</span></p>
                            </span>
                        </div>
                    </div>
                </v-card>
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'

    export default {
        components: { PageHero }
    }
</script>
